module.exports = __webpack_public_path__ + "static/media/battle_dwarf.goldenhero.3e83b101.jpeg";